// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1Hxk0","footer":"ReportModalFilter_footer__21jwE"};